import React, {useCallback} from 'react'
import {ButtonLink, TrashBinIcon} from '@modifi/ui'

type DeleteIntermediaryShareholderButtonProps = {
  onClick: () => void
  externalShareholderCompanyId: string
}

const DeleteIntermediaryShareholderButton: React.FC<DeleteIntermediaryShareholderButtonProps> = ({
  onClick,
  externalShareholderCompanyId,
}) => {
  const handleClick = useCallback(
    (e: React.UIEvent) => {
      e.preventDefault()
      onClick()
    },
    [onClick]
  )

  return (
    <ButtonLink
      onClick={handleClick}
      iconOnly
      transparent
      type="button"
      data-target="open-delete-intermediary-shareholder-dialog"
      data-external-id={externalShareholderCompanyId}
    >
      <TrashBinIcon />
    </ButtonLink>
  )
}

export default DeleteIntermediaryShareholderButton
